<template>
  <div class="content">
    <ul>
      <li v-for="(error, index) in props.errors" :key="index">
        {{ error[0].text || error[0] }}
      </li>
    </ul>
  </div>

  <button @click="closePopup" class="btn btn-blue">
    {{ trans("modals.error_popup.popup_btn") }}
  </button>
</template>

<script setup lang="ts">
  import { trans } from "@/utils/trans";

  const emit = defineEmits(["closeForm", "changeTitle", "setModalHeightAuto"]);

  const props = defineProps<{ errors: Record<string, string[]> }>();

  const closePopup = () => {
    emit("closeForm");
  };
</script>

<style lang="scss" scoped>
  .content {
    font-size: 20px;
  }
  .btn {
    width: 165px;
    height: 57px;
    margin: 60px auto 0;
    font-size: 18px;
  }
</style>
